import { api, defaultQueriesFor } from '../apiSlice';

export const eventApi = api
  .enhanceEndpoints({ addTagTypes: ['Event'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'Event', 'Events', true),

      getOccurrenceById: build.query({
        query: (id) => ({
          url: `/events/occurrence/${id}`,
        }),
        providesTags: ['Event'],
      }),

      blackoutOccurrence: build.mutation({
        query: (id) => ({
          url: `/events/${id}/blackout_occurrence`,
          method: 'POST'
        }),
        invalidatesTags: ['Event'],
      }),

      createBookings: build.mutation({
        query: (params) => ({
          url: `/events/${params.event_id}/create_bookings`,
          method: 'PUT',
          body: {
            event: {
              truck_id: params.truck_id,
              recurring: params.recurring ? params.recurring : false,
              recurrence_rule: params.recurrence_rule ? params.recurrence_rule : null,
              recurrence_start: params.recurrence_start ? params.recurrence_start : null,
              occurrences: params.occurrences
            }
          }
        }),
        invalidatesTags: ['Event'],
      }),

      cancelBooking: build.mutation({
        query: (params) => ({
          url: `/events/${params.event_id}/cancel_booking`,
          method: 'POST',
          body: {
            event: {
              booking: {
                id: params.booking_id,
              }
            },
            cancellation_reason: params.cancellation_reason,
            cancellation_explanation: params.cancellation_explanation
          }
        }),
        invalidatesTags: ['Event'],
      }),

      updateBooking: build.mutation({
        query: (params) => ({
          url: `/events/${params.event_id}/update_booking?${new URLSearchParams(params).toString()}`,
          method: 'POST',
          body: {
            event: {
              booking: {
                id: params.booking_id, status: params.status
              },
              include_event: params.include_event,
            }
          }
        }),
        invalidatesTags: ['Event'],
      }),

      addTruckToEvent: build.mutation({
        query: (params) => ({
          url: `/events/${params.eventId}/add_truck?include_locations=${params.includeLocations === true}`,
          method: 'POST',
          body: {
            event: {
              truck_id: params.truckId,
              no_charge: params.noCharge,
              include_event: params.include_event,
            }
          }
        }),
        invalidatesTags: ['Event'],
      }),

      deleteTruckFromEvent: build.mutation({
        query: (params) => ({
          url: `/events/${params.event_id}/delete_truck?${new URLSearchParams(params).toString()}`,
          method: 'POST',
          body: {
            event: {
              booking_id: params.booking_id,
              include_event: params.include_event,
            }
          }
        }),
        invalidatesTags: ['Event'],
      }),

    }),
  });

export const {
  useAddTruckToEventMutation,
  useBlackoutOccurrenceMutation,
  useCancelBookingMutation,
  useCreateBookingsMutation,
  useCreateEventMutation,
  useDeleteEventMutation,
  useDeleteTruckFromEventMutation,
  useGetEventByIdQuery,
  useGetEventsQuery,
  useGetOccurrenceByIdQuery,
  useUpdateBookingMutation,
  useUpdateEventMutation,
} = eventApi;
